// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app_order_redirect{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100vh;width:100%}.app_order_redirect h3{font-family:Montserrat;font-weight:500;font-size:25px;line-height:24px;letter-spacing:0%;text-align:center;vertical-align:middle;color:#71667f}", ""]);
// Exports
module.exports = exports;
